import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';
import Select from 'react-select';
import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";
import {VarHelper} from "common-import/helpers";

const initial = {
  email: "",
  firstName: "",
  lastName: "",
  password: "",
  type: [],
  multiple: [],
  file: null,
  isSaving: false,
  isUploading: false,
};

@inject("userStore") @observer
class ImportUsers extends Component {

  constructor(props) {
    super(props);
    this.state = initial;
  }

  uploadXLSX = (e) => {
    !!e && e.preventDefault();
    this.setState({
      isUploading: true,
      file: e.target.files[0]
    });
    VarHelper.readXLSX(e, (data) => {
      let multiple = VarHelper.formatDataXLSX(data["User"]);
      const notifySetting = VarHelper.formatDataXLSX(data["notifySetting"]);
      multiple = this.syncData(multiple, 'notifySetting', notifySetting);
      this.setState({ isUploading: false, multiple });
    }, ['User', 'notifySetting']);
  };

  /*
  * @param original
  * @param field // field name: works, materials...
  * @param data
* */
  syncData = (original = [], field, data = []) => {
    return original.map((item) => {
      const filterData = data.filter(itm => item.STT === itm.STTU);
      return {...item, [field]: this.formatNotifySetting(filterData)};
    });
  };

  formatNotifySetting = (settings) => {
    return {
      trackingProject: settings.trackingProject.toLowerCase() === 'yes',
      submitBid: settings.submitBid.toLowerCase() === 'yes',
      evaluateProfile: settings.evaluateProfile.toLowerCase() === 'yes',
      shareProject: settings.shareProject.toLowerCase() === 'yes',
      sendMessage: settings.sendMessage.toLowerCase() === 'yes',
      projectExpire: settings.projectExpire.toLowerCase() === 'yes',
      confirmInvited: settings.confirmInvited.toLowerCase() === 'yes',
      houselinkSendMessage: settings.houselinkSendMessage.toLowerCase() === 'yes',
      haveSuitableSubscription: settings.haveSuitableSubscription.toLowerCase() === 'yes',
    }
  };

  formatPayload = (data, type = 'create') => {
    let copy;
    let typeFormat = {
      typeArray: ["type"],
      typeString: ["firstName", "lastName", "email", "password"],
    };

    if (type === 'update') {
      typeFormat = {
        typeObject: ["notifySetting"],
        typeString: ["id", "name", "address", "email", "password", "country", "city", "district", "phone", "avatar", "cover", "language", "about"],
      };
    }

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }
    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  submitMultiple = async () => {
    const { userStore } = this.props;
    const { multiple } = this.state;
    if (!multiple.length) return null;
    this.setState({ isSaving: true });
    for (let i = 0; i < multiple.length; i++) {
      // uploadStatus: 0 - uploading, 1 - uploaded success, 2 - uploaded failure
      multiple[i]['uploadStatus'] = 0;
      this.setState({ multiple });
      const isArr = Array.isArray(multiple[i]["type"]);
      multiple[i]["type"] = isArr ? multiple[i]["type"] : multiple[i]["type"].split(",");
      const payload = this.formatPayload(multiple[i]);
      const res = await userStore.register(payload);
      if (!!res.error) {
        multiple[i]['uploadStatus'] = 2;
        multiple[i]['uploadErrorMessage'] = res.error;
      } else {
        multiple[i]['uploadStatus'] = 1;
      }
      this.setState({ multiple });
    }
    window.toast.info('Finish!');
    this.setState({ isSaving: false, file: null });
  };

  reset = () => {
    this.setState({
      multiple: [],
      file: null,
      isSaving: false,
      isUploading: false,
    });
  };

  renderMultipleImport = () => {
    const { isSaving, multiple, file, isUploading } = this.state;
    const adding = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 0);
    const successList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 1);
    const errorList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 2);
    const renderUploading = () => {
      if (!isSaving && multiple.length) return (<h6>{multiple.length} items will be added.</h6>);
      else if (isSaving && multiple.length) return (<h6>Adding: {adding.length && !!adding[0].email ? adding[0].email : ''}</h6>);
    };
    const style = {
      maxHeight: '200px',
      overflowY: 'auto',
    };
    const renderSuccessList = () => {
      return <div style={{marginTop: '24px'}}>
        <h6>Success ({successList.length})</h6>
        <div style={style}>
          {successList.map((item, index) => {
            return <p className="text-success" key={'success'+index}>{item.STT}: {item.email}</p>
          })}
        </div>
      </div>
    };
    const renderErrorList = () => {
      return <div style={{marginTop: '24px'}}>
        <h6>Failure ({errorList.length})</h6>
        <div style={style}>
          {errorList.map((item, index) => {
            return <p className="text-danger" key={'success'+index}>{item.STT}: {item.email} - {item.uploadErrorMessage}</p>
          })}
        </div>
      </div>
    };
    return (
      <Card>
        <CardHeader>
          <i className="fa fa-envelope-open"> </i> Create multiple contacts - Upload files
        </CardHeader>
        <CardBody>
          <div style={{marginBottom: '16px'}}>
            <a target="_blank" href="https://drive.google.com/drive/folders/1YjwJTADWCYt3C5RoS-G0JOmFeDHT28AG?usp=drive_open">
              Sample data here
            </a>
          </div>
          <Form action="" method="post" className="form-horizontal">
            <FormGroup>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <div style={{marginBottom: 0}} className="form-group group-file-upload">
                    <input onChange={e => this.uploadXLSX(e)} type="file" id="upload-files" name="upload-files" style={{display: "none"}}/>
                    <label className="btn btn-primary" htmlFor="upload-files"><i className="fa fa-file"> </i> {isUploading ? 'Uploading...' : 'Upload'}</label>
                  </div>
                </InputGroupAddon>
                <Input type="text" disabled={true} value={!!file ? file.name : 'File path .xlsx .xls'}/>
              </InputGroup>
            </FormGroup>
          </Form>
          {renderUploading()}
          {successList.length ? renderSuccessList() : null}
          {errorList.length ? renderErrorList() : null}
        </CardBody>
        <CardFooter>
          <button type="submit" className="btn btn-sm btn-success" disabled={isSaving} onClick={() => this.submitMultiple()}>
            <i className="fa fa-dot-circle-o"> </i> {isSaving ? 'Submitting...' : 'Submit'}
          </button>
          <Button type="reset" size="sm" color="danger" onClick={() => this.reset()}>
            <i className="fa fa-ban"> </i> Reset
          </Button>
        </CardFooter>
      </Card>
    );
  };

  handleSelectTypes = (selectedOption) => {
    let type = [];
    selectedOption.map((item) => {
      type = [...type, item.value];
    });
    this.setState({ type });
  };

  renderSingleImport = () => {
    const types = [
      { label: 'ProjectOwner', value: 'ProjectOwner' },
      { label: 'Contractor', value: 'Contractor' },
      { label: 'Supplier', value: 'Supplier' },
    ];
    const getSelected = () => {
      if (this.state.type.length) {
        return this.state.type.map(item => {
          return { label: item, value: item };
        });
      }
      return [];
    };
    return (
      <Card>
        <CardHeader>
          <i className="fa fa-envelope-open"> </i> Create a user
        </CardHeader>
        <CardBody>
          <Form action="" method="post" onSubmit={this.submitCreateOneUser}>
            <FormGroup>
              <Label htmlFor="nf-email">Email</Label>
              {makeInput(this, "email")(<Input type="text" value="12" />)}
            </FormGroup>
            <FormGroup>
              <Label htmlFor="nf-email">First name</Label>
              {makeInput(this, "firstName")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label htmlFor="nf-email">Last name</Label>
              {makeInput(this, "lastName")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label htmlFor="nf-email">Password</Label>
              {makeInput(this, "password")(<Input type="text" />)}
            </FormGroup>
            <FormGroup>
              <Label htmlFor="multiple-select">Account Type</Label>
              <Select isMulti
                      value={getSelected()}
                      onChange={this.handleSelectTypes}
                      options={types}
              />
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <Button type="submit" size="sm" color="primary" onClick={this.submitCreateOneUser}><i className="fa fa-dot-circle-o"> </i> Save</Button>
          <Button type="reset" size="sm" color="danger" onClick={() => this.resetFormState()}><i className="fa fa-ban"> </i> Cancel</Button>
        </CardFooter>
      </Card>
    )
  };

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-6">{this.renderSingleImport()}</div>
          <div className="col-md-6">{this.renderMultipleImport()}</div>
        </div>
      </div>
    );
  }

  submitCreateOneUser = async e => {
    !!e && e.preventDefault();
    const { userStore } = this.props;
    const { email, firstName, lastName, password, type } = this.state;
    let userType;
    switch (type) {
      case "1": userType = ["ProjectOwner"]; break;
      case "2": userType = ["Contractor"]; break;
      case "3": userType = ["Supplier"]; break;
    }
    let registerResult = await userStore.register({ email, firstName, lastName, password, type: userType });
    if(!!registerResult.error) window.toast.error("Error, please try again "+ JSON.stringify(registerResult.error));
    else {
      window.toast.success("Created successfully.");
      this.resetFormState();
    }
  };

  resetFormState = () => {
    this.setState({ email:"", firstName: "", lastName: "", type: "1", password: "" })
  }
}

export default ImportUsers;



// WEBPACK FOOTER //
// ./src/views/Users/Import.js